import {Panorama} from 'mapy-cz';

let promise: Promise<typeof Panorama>;

export function loadMapyCz(): Promise<typeof Panorama> {
    promise = promise || new Promise<typeof Panorama>(resolve => {
        const script = document.createElement('script');
        script.src = 'https://api.mapy.cz/js/panorama/v1/panorama.js';
        script.async = true;
        script.onload = () => {
            resolve((window as any).Panorama);
        };
        document.body.appendChild(script);
    });

    return promise;
}
